import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./CMSSearchItem.module.css";

/**
 * View component. Displays CMS item for search list.
 */
export function CMSSearchItem({ cmsItem, onAdd }) {
  return (
    <div className={styles.container}>
      <div className={styles.addBtn} onClick={() => onAdd(cmsItem)}>
        Add
      </div>
      <div className={styles.title}>
        {cmsItem.title} ({cmsItem.contentId})
      </div>
    </div>
  );
}

CMSSearchItem.propTypes = {
  /**
   * CMS item content.
   */
  cmsItem: PropTypes.string,
  /**
   * Function that fires when add is clicked.
   */
  onAdd: PropTypes.string,
};
